import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BaseDialog from "../../components/BaseDialog";
import { Box, Button, LinearProgress } from "@mui/material";
import TextField from "../../components/TextField";
import { calculateValueFromEvent, toComboValues, toComboValuesRenderer } from "../../components/Utils";
import { hasErrors, required, validate, validateAll } from "../../components/Validators";
import LoadingDialog from "../../components/LoadingDialog";
import DialogOkCancel from "../../components/DialogOkCancel";
import useApi from "../../api";
import { isUndefined } from "lodash";
import { AppContext } from "../../App";
import { aperturaManual, consultarCarriles } from "../../api/controlador";
import ComboSelect from "../../components/ComboSelect";
import { COMBO_CARRIL_RENDER } from "../carriles/ListadoCarriles";
import { RENDER_TAGS } from "../tags/ConsultaTagPanel";

/* const MOTIVOS = [
    { id: 'SIN_LECTURA_TAG', nombre: 'Sin letura del tag' },
    { id: 'OTRO', nombre: 'Otro' },
]
 */

const fieldsValidators = {
    'carrilId': [required],
    'comentario': [required],
    //'motivo': [required],
}

const initialData = {
    carrilId: '',
    //motivo: '',
    comentario: '',
}

const defaultErrors = {
    carrilId: '',
    //motivo: '',
    comentario: '',
}

const AperturaManualDialog = ({ ...props }) => {

    const appContext = useContext(AppContext);
    let { state } = useLocation();
    const navigate = useNavigate();

    // const { comercioId } = useParams();
    const { tag, sentido } = state;

    const { notificar } = appContext;

    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState(defaultErrors);
    const [dirty, setDirty] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({ open: false, msg: null });
    const [open, setOpen] = useState(true);

    const [carriles, setCarriles] = useState(null);

    const [{ data: carrilesData, loading: loadingCarriles }, carrilesApi] = useApi();
    const [{ data: aperturaManualData, loading: loadingAperturaManual }, aperturaManualApi] = useApi();

    useEffect(() => {
        carrilesApi(consultarCarriles({ tipos: sentido === 'ENTRADA' ? 'ENTRANCE, NEST_ENTRANCE' : 'EXIT, NEST_EXIT' }));
    }, []);

    useEffect(() => {
        if (carrilesData) {
            setCarriles(carrilesData);
        }
    }, [carrilesData])

    useEffect(() => {
        if (!isUndefined(aperturaManualData)) {
            notificar("Apertura manual registrada");
            setOpen(false);
            if (props.onShouldUpdate) { //Avisamos por si quieren actualizar algo...
                props.onShouldUpdate();
            }
        }
    }, [aperturaManualData])

    useEffect(() => {
        if (dirty === true) {
            const errors = validateAll(data, fieldsValidators);
            const isErrors = hasErrors(errors);
            setIsValid(!isErrors);
        }
    }, [data])

    const handleChangeValue = name => event => {
        const value = calculateValueFromEvent(event);
        const error = validate(value, fieldsValidators[name]);

        setData({
            ...data,
            [name]: value
        });
        setErrors({
            ...errors,
            [name]: error
        })
        setDirty(true);
    }

    const handleOnBlur = name => event => {
        const value = event.target.value;
        const error = validate(value, fieldsValidators[name]);
        setErrors({
            ...errors,
            [name]: error
        })
    }

    const handleGuardar = () => {
        if (isValid) {
            setConfirmDialog({
                open: true,
                msg: <>
                    ¿Confirmas realizar la apertura manual?<br /><br />
                    Esta acción no se puede deshacer.
                </>,
                onOk: handleConfirmaRegistrar,
                onCancel: handleCancelRegistrar
            });
        }
    }

    const handleCancelRegistrar = () => {
        setConfirmDialog({ open: false, msg: null })
    }

    const handleConfirmaRegistrar = () => {
        setConfirmDialog({ open: false, msg: null })
        const body = {
            ...data,
            tag
        }
        aperturaManualApi(aperturaManual(body));
    }

    const handleExited = () => {
        navigate(-1);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const title = 'Apertura manual';

    return (
        <>
            <BaseDialog open={open} onExited={handleExited} title={title} onClose={handleClose} fullWidth
                actions={
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button onClick={handleClose} color="primary">Cerrar</Button>
                        <Button onClick={handleGuardar} color="primary" variant="contained" disabled={!isValid}>Guardar</Button>
                    </Box>
                }>
                <Box>
                    <>
                        Apertura manual para el tag {RENDER_TAGS(tag)}.<br /><br />
                        Para dar apertura manual, el vehículo debe estas sobre el sensor de la boletera del carril seleccionado.
                    </>
                    <ComboSelect
                        fullWidth
                        required
                        label={sentido === 'ENTRADA' ? "Carril de entrada" : "Carril de salida"}
                        field="carrilId"
                        disabled={carriles && carriles.length === 0}
                        value={data.carrilId}
                        onChange={handleChangeValue('carrilId')}
                        onBlur={handleOnBlur('carrilId')}
                        options={toComboValuesRenderer(carriles, COMBO_CARRIL_RENDER)}
                        errors={errors}
                    />
                    {loadingCarriles && <LinearProgress />}
                    {/*                     <ComboSelect
                        fullWidth
                        required
                        label="Motivo"
                        field="motivo"
                        value={data.motivo}
                        onChange={handleChangeValue('motivo')}
                        onBlur={handleOnBlur('motivo')}
                        options={toComboValues(MOTIVOS)}
                        errors={errors}
                    /> */}
                    <TextField
                        fullWidth
                        label="Comentario"
                        field="comentario"
                        value={data.comentario}
                        onChange={handleChangeValue('comentario')}
                        onBlur={handleOnBlur('comentario')}
                        errors={errors}
                    />
                </Box>
            </BaseDialog>
            <DialogOkCancel {...confirmDialog} />
            <LoadingDialog open={loadingAperturaManual} />
        </>
    );
}

export default AperturaManualDialog;